<div class="searchbar-wrapper flex items-center content-between w-full">
  <input #searchbar type="text" [placeholder]="placeholder">
  <i class="fal fa-search icon"></i>
</div>